import * as React from 'react';
import EnrollmentValidTriggerResultExplanation from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/triggerChecks/EnrollmentValidTriggerResultExplanation';
import EnrollmentCheckValidationResultExplanation from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/enrollmentChecks/EnrollmentCheckValidationResultExplanation';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationResultExplanation = ({
  validationResult,
  flowRevision,
  objectId
}) => {
  if (validationResult.type === 'VALID_TRIGGER_CHECK') {
    return /*#__PURE__*/_jsx(EnrollmentValidTriggerResultExplanation, {
      validationResult: validationResult.result,
      flowRevision: flowRevision
    });
  }
  return /*#__PURE__*/_jsx(EnrollmentCheckValidationResultExplanation, {
    validationResult: validationResult.result,
    flowRevision: flowRevision,
    objectId: objectId
  });
};
export default ValidationResultExplanation;